import { IndividualNDataEdit, IndividualNDataEditProps } from "./individualNDataEdit.js";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "./toolBar.js";
import { Grid } from "./grid.js";
import { Helper } from "../util/helper.js";
import { IndividualDataHelper } from "../util/individualDataHelper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { Config } from "../config/config.js";
import { DialogHelper } from "../util/dialogHelper.js";
import { HTTPService } from "../util/httpManager.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
export class DynamicGrid extends React.Component<DynamicGridProps, any>{
    private icuh = Helper;
    private dataUrl: string = null;
    private translations: StringKeyDictionary<string>;
    private dataLoaded = false;
    private columnExists = false;
    private indivHelper = IndividualDataHelper.create();
    private gridData = [];
    private gridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: false,
        selectable: true,
        resizable: true,
        scrollable: true,
        columns: [],
        schema: {
            model: {
                fields: {}
            }
        }
    };
    private config = {
        fieldsMetadata: [],
        categoryMetadata: {},
        editWindowCache: {
            metadata: {
                tabs: []
            },
            dataSources: {},
            fieldsListObject: {},
            fieldsMetaData: [],
            keys: {
                id1Name: null,
                id2Name: null
            }
        },
        fieldsListObject: {}
    };
    private selectedItem = null;

    private getGridData() {
        HTTPService.get(this.dataUrl.replace("{0}", encodeURIComponent(this.props.value)))
            .then(result => {
                if (result.Code === 0) {
                    this.gridData.length = 0;
                    for (let i = 0; i < result.Data.data.length; i++) {
                        this.gridData.push(this.convertToGridItem(result.Data.data[i]));
                    }
                    this.setState({}, () => {
                        this.props.onDataLoaded(this.props.field, this.gridData);
                    });
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private convertTypeForGrid(type) {
        switch (type) {
            case 1://numeric
            case 2://currency
            case 3://intnumeric
                return "number";
            case 4://checkbox
                return "boolean";
            case 5://datetimepicker
                return "date";
            case 0://textbox
            case 6://combobox
            case 7://multilangcombobox
            case 8://multilinetext
            default:
                return "string";
        }
    }

    private convertToGridItem(individualArray) {
        const result = {};

        for (var i = 0; i < individualArray.length; i++) {
            result[individualArray[i].Name] = individualArray[i].Value;
        }
        return result;
    }

    private openEditWindow = (dataItem) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.translations["WebSMS.Additional.EditNData"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.getGridData();
        });

        sheet.show(() => {
            let nDataEntity, hasDefaults = false;
            if (this.icuh.hasValue(dataItem)) {
                nDataEntity = JSON.parse(JSON.stringify(dataItem));
                nDataEntity.IsNew = false;
                nDataEntity.RecordRight = {
                    CanRead: true,
                    CanWrite: true
                };

                // ComboBox Text auf Nr switchen
                for (let prop of this.config.fieldsMetadata) {
                    if (prop && prop.Type == 7 && prop.Value.Choices && this.icuh.hasValue(nDataEntity[prop.Name])) {
                        let index = Helper.findIndex(prop.Value.Choices, "Item2", nDataEntity[prop.Name]);
                        if (index !== -1)
                            nDataEntity[prop.Name] = prop.Value.Choices[index].Item1;
                    }
                }
            } else {
                nDataEntity = {
                    IsNew: true,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    }
                }

                let count = 0;
                for (let prop in this.config.editWindowCache.fieldsListObject) {
                    if (prop && this.config.editWindowCache.fieldsListObject[prop] && Helper.hasValue(this.config.editWindowCache.fieldsListObject[prop].defaultValue)) {
                        nDataEntity[prop] = this.config.editWindowCache.fieldsListObject[prop].defaultValue;
                        count++;
                    }
                }
                hasDefaults = count > 0;
            }
            const props: IndividualNDataEditProps = {
                mainContext: this.props.context,
                context: {
                    contextType: "ndataedit",
                    key1: "id",
                    keyVal1: this.props.context.keyVal1
                },
                isWindow: true,
                metadata: {
                    tabs: this.config.editWindowCache.metadata.tabs,
                    menuDataSource: [{
                        text: this.translations["Standard.OK"],
                        onClick: "saveEnabled && save(true)",
                        type: "save",
                        show: true
                    }],
                    additional: {
                        objects: [

                        ]
                    }
                },
                entity: nDataEntity,
                handleEval: this.props.handleEval,
                translations: this.translations,
                dataSources: this.config.editWindowCache.dataSources,
                hasDefaults: hasDefaults,
                type: "Dynamic",
                tableName: this.props.field.tableName,
                tableNameId: this.props.value,
                fieldsMetadata: this.config.fieldsMetadata,
                keys: this.config.editWindowCache.keys,
                handleMenuSelect: null,
                enableMenuItem: null,
                handleCreateValidator: null,
                handleFieldChange: null,
                handleDataLoaded: null,
                onChange: null
            };

            sheet.mountContent(IndividualNDataEdit, props);
        });
    }

    private create = () => {
        this.openEditWindow(null);
    }

    private open = (dataItem: any) => {
        this.openEditWindow(dataItem);
    }

    private remove = (dataItem) => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                const url = 'DynamicIndividualN/DeleteDynamic';
                var toSend = {
                    tableName: this.props.field.tableName,
                    id1: dataItem[this.config.editWindowCache.keys.id1Name],
                    id2: dataItem[this.config.editWindowCache.keys.id2Name]
                };

                HTTPService.post(url, toSend)
                    .then((result) => {
                        this.getGridData();
                    })
                    .catch(() => {
                        NotificationHelper.showErrorMessage(this.translations["Standard.Msg.SpeichernFehler"]);
                    });
            }
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.create();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.open(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this.remove(dataItem);
        }
    }

    handleClickCustomButton = (id: string, dataItem: any, allItems?: Array<any>) => {
        if (id == "apply") {
            this.props.onChange({ model: this.props.field.applyTargetField }, dataItem.pos);
        }
    }

    onSelectionChanged = (dataItem) => {
        this.selectedItem = dataItem;
        this.setState({});
    }

    componentDidMount() {
        this.dataUrl = "DynamicIndividualN/GetDynamicTableData?id1={0}"
            + "&tableName=" + encodeURIComponent(this.props.field.tableName);

        if (Helper.hasValue(this.props.field.maxRows))
            this.dataUrl += "&maxRows=" + encodeURIComponent(this.props.field.maxRows);

        if (Helper.hasValue(this.props.field.orderBy))
            this.dataUrl += "&orderBy=" + encodeURIComponent(this.props.field.orderBy);

        Promise.all([
            HTTPService.get(this.dataUrl.replace("{0}", encodeURIComponent(this.props.value))),
            this.icuh.getTranslations(["Standard.Msg.Loeschen", "Standard.Msg.SpeichernFehler", "Standard.Msg.SpeichernErfolgreich",
                "Standard.OK", "Standard.Neu", "Standard.Speichern", "Standard.CloseBtn", "WebSMS.Additional.NData",
                "WebSMS.Additional.EditNData", "Standard.BitteWählen", "Standard.Editieren", "Standard.Loeschen",
                "Adresse.AdresseSuchen", "Maschine.Maschinensuche", "Projekt.Projektsuche", "Ressource.Ressourcensuche",
                "Ansprechpartner.Ansprechpartnersuche", "WebSMS.Title.ProcedureSearch", "MonitorBaum.NeuLaden", "Standard.Benutzersuche"])
        ]).then(result => {
            this.translations = result[1].Data;
            const data = result[0];

            this.config.fieldsMetadata = data.Data.metadata;
            this.config.categoryMetadata = data.Data.categoryMetadata;
            const tmpEditMetadata = this.indivHelper.createMetadata(this.config, this.translations["WebSMS.Additional.NData"], "metadata", false, this.translations, null, true);
            this.config.editWindowCache.metadata = tmpEditMetadata.gui;
            this.config.editWindowCache.dataSources = tmpEditMetadata.dataSources;
            this.config.fieldsListObject = this.indivHelper.getFieldsList(this.config, tmpEditMetadata.gui);
            this.config.editWindowCache.fieldsListObject = this.config.fieldsListObject;//same ref, should not be modified
            this.config.editWindowCache.fieldsMetaData = this.config.fieldsMetadata;
            this.config.editWindowCache.keys = data.Data.keys;
            let noOfKeys = 0;

            for (let i = 0; i < this.config.fieldsMetadata.length; i++) {
                if (!this.config.fieldsMetadata[i].IsPrimaryKey && typeof this.config.fieldsListObject[this.config.fieldsMetadata[i].Name] === "object") {
                    const column = {
                        field: this.config.fieldsMetadata[i].Name,
                        title: this.config.fieldsMetadata[i].DisplayName,
                        template: null,
                        width: this.getColumnWidth(this.config.fieldsMetadata[i])
                    }
                    if (this.config.fieldsMetadata[i].Type == 5) {
                        if (this.config.fieldsMetadata[i].Display === 1) {
                            column.template = "#= data." + this.config.fieldsMetadata[i].Name + " ? " + "kendo.toString(kendo.parseDate(" + this.config.fieldsMetadata[i].Name + "), 'g') " + ":''" + "#";
                        } else {
                            column.template = "#= data." + this.config.fieldsMetadata[i].Name + " ? " + "kendo.toString(kendo.parseDate(" + this.config.fieldsMetadata[i].Name + "), 'd') " + ":''" + "#";
                        }
                    }
                    this.gridOptions.columns.push(column);
                }
                if (this.config.fieldsMetadata[i].IsPrimaryKey === true) {
                    noOfKeys++;
                }
                this.gridOptions.schema.model.fields[this.config.fieldsMetadata[i].Name] = { type: this.convertTypeForGrid(this.config.fieldsMetadata[i].Type) };
            }
            if (this.config.fieldsMetadata.length > noOfKeys) {
                this.columnExists = true;
            }
            for (let i = 0; i < data.Data.data.length; i++) {
                this.gridData.push(this.convertToGridItem(data.Data.data[i]));
            }

            this.dataLoaded = true;
            this.props.onDataLoaded(this.props.field, this.gridData);
            this.setState({});
        });
    }

    private getColumnWidth = (columnMetaData: any): number => {
        switch (columnMetaData.Type) {
            // Numeric, CheckBox, DateTime
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                return 80;
            // TextBox + ComboBox
            case 0:
            case 6:
            case 7:
                return 120;
            // Multiline
            case 8:
                return 200;
            default:
                return 80;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.dataLoaded && this.props.value != prevProps.value) {
            this.getGridData();
        }
    }

    render() {
        let content = null;
        if (this.dataLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.translations["Standard.Neu"], enabled: !this.props.disabled && this.columnExists && this.props.value !== null && this.props.value !== "" });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this.translations["Standard.Editieren"], enabled: !this.props.disabled && this.columnExists && this.props.value !== null && this.props.value !== "" });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.translations["Standard.Loeschen"], enabled: !this.props.disabled && this.columnExists && this.props.value !== null && this.props.value !== "" });

            const customButtons: Array<GridCustomToolBarButton> = [];
            if (this.props.field.applyActive === true) {
                customButtons.push({
                    autoEnabledOnRecordSelected: true,
                    caption: Config.translations.apply,
                    enabled: !this.props.disabled && this.columnExists && this.props.value !== null && this.props.value !== "",
                    id: "apply",
                    iconClass: "k-i-arrow-n"
                });
            }

            content =
                <div style={{ height: "100%", width: "100%" }}>
                    <div style={this.props.field.style}>
                        <Grid data={this.gridData} options={this.gridOptions} id={"dynamicGrid-" + this.props.field.tableName}
                            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton}
                            customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton}
                            onSelectionChanged={this.onSelectionChanged} />
                    </div>
                </div>
        }

        return (content);
    }
}
export interface DynamicGridProps extends BaseComponentProps {
    handleEval(action: string, prepare?: any);
    onDataLoaded?(field: { model: string }, data: any);
    field: DynamicGridField;
}

export interface DynamicGridField extends BaseField {
    tableName: string;
    style?: any;
    applyActive?: boolean,
    applyTargetField?: string,
    maxRows?: number;
    orderBy?: string;
}